export default "__VITE_ASSET__CMw0MKQD__"